import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IInvoiceItem {
  _id: string;
  amount: string;
  serviceType: string;
  productName: string;
  invoiceDocId: number;
  status: string;
  paymentLabel: string;
  date: string;
  link: string;
}

export interface IInvoiceSelector {
  id: string;
  type: MESSAGES.INVOICE_SELECTOR;
  nodeId: string;
  items: IInvoiceItem[];
  pageSize: number;
  rm: boolean;
  role?: string;
}

export const createInvoiceSelector = (data): IInvoiceSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.INVOICE_SELECTOR,
  nodeId: data.nodeId,
  items: data.items,
  pageSize: data.pageSize,
  rm: Boolean(data.rm),
});
